import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { useUserHomepageSetting } from '~/scenes/PortalViews/components/RedirectToPortalHomepage/useUserHomepageSetting';

export const RedirectToPortalHomepage = () => {
  const { t } = useTranslation();
  const { initialized, useWorkspaceAsHomepage } = useUserHomepageSetting();

  if (!initialized) {
    return <LoadingView>{t('redirectingToHomepage')}</LoadingView>;
  }

  return (
    <Redirect
      to={`/portal/${useWorkspaceAsHomepage ? 'my-workspace' : 'home'}`}
    />
  );
};
